module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/volume-full-588ea39cdc927825fe3badbd227db55d.svg";